export class JobPhoto {
    constructor(public JPID?, public JID?, public Photo?) { }
}